var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('BaseCardContainer',{attrs:{"title":"Nouveau bloctext","noFooter":""},scopedSlots:_vm._u([{key:"footer",fn:function({}){return [_vm._v(" Footer Mail BlocText Create ")]}}])},[_c('BlocTextForm',{attrs:{"id":"form"},on:{"onSubmit":_vm.onSubmit,"onCancel":_vm.onCancel}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }